export interface IAuthTokenStore {
  logout(): void;
}

export class LocalAuthStore implements IAuthTokenStore {
  logout() {}
}
